<script setup>
import PlatformPanel from '../../panels/Platform.vue';
</script>

<template>
  <table-base
    has-phone-layout
    :on-add="onAdd"
    :add-label="addLabel"
    :columns="columns"
    :items="items"
    :pages="pages"
    :pagination="pagination"
    :is-loading="isLoading"
    has-custom-items-template
    :on-select-item="onSelectItem"
    :on-update-pagination="onUpdatePagination"
    :on-change-page="onChangePage"
    data-cy="assets-table"
  >
    <template v-slot:item-cell="scope">
      <span
        v-if="scope.cell.column.value === 'events'"
        class="d-flex gap-4 flex-wrap"
      >
        <template v-for="(event, index) in scope.cell.item.events" :key="event.country.code + '-' + index">
          <PlatformPanel
            :country="event.country"
            :custom-title="event.title + ` (${event.country.code})`"
            v-show="index < 2 || expandedRows.includes(scope.cell.item.id)"
          />
        </template>
        <v-icon v-if="scope.cell.item.events.length > 2" @click="toggleExpandCategories($event, scope.cell.item.id)">
          {{ expandedRows.includes(scope.cell.item.id) ? 'expand_less' : 'expand_more' }}
        </v-icon>
        <span v-if="scope.cell.item?.events?.length === 0">
          -
        </span>
      </span>
      <template v-else>
        {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
      </template>
    </template>
  </table-base>
</template>

<script>
import columns from '../../../config/events/assetsColumns';
import { extractNestedProp } from '@/utils';

export default {
  props: {
    onAdd: {
      type: Function,
      default: null,
    },
    addLabel: {
      type: String,
      default: undefined,
    },
    items: {
      type: Array,
      required: true,
    },
    pages: {
      type: Number,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    onSelectItem: {
      type: Function,
      required: true,
    },
    onUpdatePagination: {
      type: Function,
      required: true,
    },
    onChangePage: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      expandedRows: [],
      columns,
    };
  },
  methods: {
    toggleExpandCategories(e, itemId) {
      e.stopPropagation();

      const itemIndex = this.expandedRows.findIndex(i => i === itemId);

      if (itemIndex > -1) {
        this.expandedRows.splice(itemIndex, 1);
      } else {
        this.expandedRows.push(itemId);
      }
    },
    displayColumnValue(item, value) {
      return extractNestedProp(item, value);
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../../assets/styles/theme' as *;

.v-datatable {
  min-width: $table-min-width;
}
</style>
